import { Model } from "@vuex-orm/core";
import Project from "./Project";

export default class Milestone extends Model {
  static entity = "milestones";
  static url = "/milestone"
  static friendlyName = "Milestone"

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      date: this.attr(null),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      projectId: this.attr(null),
      project: this.belongsTo(Project, "projectId"),
    };
  }
}
